// import React,{Component} from "react";

// // reactstrap components
// import {
//   Col,
//   Progress,
//   Label,
//   Button,
//   Input
// } from "reactstrap";
// import {base,s3base} from "api.js";
// import { Checkbox } from '@mui/material';
// import Sound from 'react-sound';
// import "components/custom.css";
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
// import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";

// class McqMulti extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       question:"",
//       secondCount:10,
//       recordCount:0,
//       recordId:1,
//       intervalId:0,
//       questionId:"",
//       reset:false,
//       soundStatus:true,
//       selectedValue:[],
//       soundPer:0,
//       volume:100,
//       correctFlag:true,
//       resultObj:{},
//       playbackSpeed: 1,
//       soundKey: 0,
//       question_audio: null,
//       defaultSelectedVoice: null,
//     };
//   }
//   componentDidMount() {
//   	if (!this.props.answer) {
//       // select audio.
//       let question_audio = null;
//       let defaultSelectedVoice = null;
//       if ('question_audios' in this.props.data && this.props.data.question_audios.length > 0) {
//         let x = parseInt(Math.random() * 6);

//         const { question_audios } = this.props.data;
//         question_audio = `${s3base}/${question_audios[x].value}`;
//         defaultSelectedVoice = question_audios[x].label;
//       } else {
//         const { media_link } = this.props.data;
//         question_audio = `${s3base}${media_link}`;
//       }

//       var intervalId = setInterval(this.timer, 1000);
//       this.setState({
//         intervalId,
//         question_audio,
//         defaultSelectedVoice
//       });
//     }
//   }

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);

//         let question_audio = null;
//         let defaultSelectedVoice = null;
//         if ('question_audios' in props.data && props.data.question_audios.length > 0) {
//           let x = parseInt(Math.random() * 6);

//           const { question_audios } = props.data;
//           question_audio = `${s3base}/${question_audios[x].value}`;
//           defaultSelectedVoice = question_audios[x].label;
//         } else {
//           const { media_link } = props.data;
//           question_audio = `${s3base}${media_link}`;
//         }

//   			return {
//           correctFlag: true,
//           recordCount: 0,
//           soundPer: 0,
//           isRecording: false,
//           secondCount: 10,
//           questionId: props.data.id,
//           blobURL: '',
//           reset: true,
//           soundStatus: true,
//           question_audio,
//           defaultSelectedVoice
//         };
//   		}else{
//   			if (!state.questionId) {
//   				return {correctFlag:true,questionId: props.data.id};
//   			}
//   		}
  		
//   		} 
//   }
  
//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }

// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
			
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

//   handleSongFinishedPlaying = () => {
//     this.setState({'soundStatus':false});
//     this.props.soundChecked();
//     this.props.showResult();
//   } 

//   removeItem = (array, item) => {
//     for(var i in array){
//         if(array[i]==item){
//             array.splice(i,1);
//             break;
//         }
//     }
//   }

//   handleSongPlaying = (obj) => {
//     this.setState({soundPer:obj.position*100/obj.duration});
//   }

//   changeRange = (e) => {
//       this.setState({volume: e.target.value});
//   }

// 	timerRecord = () => {
// 		if (this.state.recordCount === 40) {
// 			clearInterval(this.state.recordId);
// 			this.stop();
// 		}
// 		this.setState({ recordCount: this.state.recordCount + 1 });	
// 	}

//   handleChange = (event) => {
//     this.props.showResult();
//     let correct = this.props.data.option.filter(function (item) {
//       return item.correct == 1;
//     }).map(function (i) {
//       return i.id;
//     })
//         let arr = this.state.selectedValue;
//         let val = event.target.value;
//         arr.includes(parseInt(val))?this.removeItem(arr, parseInt(val)):arr.push(parseInt(val))
//         this.props.submit({'answer':arr,'correct':correct},true);
//         this.setState({selectedValue:arr, resultObj:{'answer':arr,'correct':correct} });
//   };

//   updateCorrect = () =>{
//     let correct = this.props.data.option.filter(function (item) {
//       return item.correct == 1;
//     }).map(function (i) {
//       return i.id;
//     })
//     this.props.submit({'answer':[],'correct':correct});
//     this.setState({correctFlag:false, resultObj: {'answer':[],'correct':correct} });
//   }
//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({secondCount:0});
//   };
// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}

//   changePlaybackSpeed = (speed) => {
//     this.setState((prevState) => ({
//       soundKey: prevState.soundKey + 1
//     }));
//     this.setState({playbackSpeed: speed});
//   }

//   changeAudio = (selected) => {

//     const { question_audios } = this.props.data;
//     const selected_audio = question_audios.filter((audio, i) => {
//       return audio.label === selected.label;
//     });

//     this.setState({
//       question_audio: `${s3base}/${selected_audio[0].value}`,
//       playStatus: Sound.status.PLAYING
//     });
//   }
  
//   render() {
//   	let question ="";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();      
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question_mcq;
//       if (this.state.correctFlag) {
//         this.updateCorrect();  
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		this.setState({intervalId: intervalId,reset:false,selectedValue:[]});
//   	}
//     return (
//       <>
//       <Col xs={12}>
//       	<h4 className="infoText"></h4>
//       </Col>
//       <div className="container-fluid">
//         <div className="row">
//           { !this.props.resultMode && <Col xs={12}>
//             <div className="col-lg-12 p-0 text-center">
//               <div className="currentStatus">
//                 <p>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
//                 {this.state.secondCount == 0 && this.state.blobURL === '' && !this.state.isRecording && ' Playing' }
                
//                 <br></br>
//                 Volume
//                  <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//                  <br></br>
//                 <Progress color="info" value={(this.state.soundPer)} />
//                 {!this.props.testMode && (
//                   <div className="d-flex justify-content-between">
//                     <div className='stop-btn'>
//                       {this.state.secondCount !== 0 && this.state.blobURL === '' && !this.state.isRecording &&
//                         <Button color="success" onClick={this.skip} size="sm">Skip</Button>
//                       }
//                     </div>
//                     <div className="stop-btn clearfix">
//                       <div className="select-voice pull-left">
//                         {this.state.defaultSelectedVoice !== null &&
//                           <SelectVoiceDropDown
//                             voices={this.props.voices}
//                             selected={this.state.defaultSelectedVoice}
//                             changeAudio={this.changeAudio}
//                           />
//                         }
//                       </div>
//                       <div className="select-speed pull-right">
//                         <PlaybackSpeedBtns
//                           changePlaybackSpeed={this.changePlaybackSpeed}
//                           playbackSpeed={this.state.playbackSpeed}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//                 </p>
                
//               </div>
              
//               <Col xs={12}>
//                 {this.props.data && !this.props.resultMode && this.state.soundStatus && this.state.secondCount === 0 &&
//                   <Sound
//                     url={this.state.question_audio}
//                     playStatus={Sound.status.PLAYING}
//                     onFinishedPlaying={this.handleSongFinishedPlaying}
//                     onPlaying={this.handleSongPlaying}
//                     volume={this.state.volume}    
//                     playbackRate={this.state.playbackSpeed} 
//                     key={this.state.soundKey}     
//                   />
//                 }
//               </Col>
//               <Col xs={12}>
//                 { this.state.blobURL && <audio src={this.state.blobURL} controls="controls" />}
//               </Col>
//             </div>
//           </Col> }
//           <Col xs={12}><h3 className="question">{question}</h3>
//             <div className="answers">
//             {this.props.data && this.props.resultMode && this.props.data.option.map(function(item){
//                     return <React.Fragment>
//                             <Label className={ this.props.answer && item.correct === 1 && 'correct-line' }>
//                                   <Checkbox
//                                       onChange={this.handleChange}
//                                       checked={this.state.selectedValue.includes(item.id)}
//                                       value={item.id}
//                                       color="default"
//                                       inputProps={{ 'aria-label': 'secondary checkbox' }}
//                                       name="answer"
//                                     />{' '}
//                                   {item.options}
//                                 </Label>
//                           </React.Fragment>;
//                   },this) }
//             {this.props.data && !this.props.resultMode && this.props.data.option.map(function(item){
//                 return <React.Fragment>
//                         <Label className={ this.props.answer && (item.correct === 1?(this.state.selectedValue.includes(item.id)?'correct-line':'blue-line'):(this.state.selectedValue.includes(item.id))?'red-line':'') }>
//                           <Checkbox
//                               checked={this.state.selectedValue.includes(item.id)}
//                               value={item.id}
//                               color="default"
//                               onChange={this.handleChange}
//                               inputProps={{ 'aria-label': 'secondary checkbox' }}
//                               name="answer"
//                             />{' '}
//                           {item.options}
//                         </Label>
//                       </React.Fragment>;
//               },this) }
//             </div>
//           </Col>
//         </div>
//       </div>
//       </>
//     );
//   }
// }
// export default McqMulti;


import React, { useState, useEffect, useRef } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import { base, s3base } from "api.js";
import { Checkbox } from '@mui/material';
import Sound from 'react-sound';
import "components/custom.css";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import { formatTimeMiliSecond } from "util/helper.js";

const McqMulti = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [selectedValue, setSelectedValue] = useState([]);
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [audioFailed, setAudioFailed] = useState(false);
  const MAX_AUDIO_RETRIES = 1;
  const intervalIdRef = useRef(intervalId);
  const recordIdRef = useRef(recordId);
  const lastSoundPerRef = useRef(0);
  const lastSoundPerTimeRef = useRef(null);
  const stallWatchdogRef = useRef(null);
  const STALL_TIMEOUT_MS = 5000;

  useEffect(() => {
    intervalIdRef.current = intervalId;
  }, [intervalId]);

  useEffect(() => {
    recordIdRef.current = recordId;
  }, [recordId]);

  // componentDidMount equivalent
  useEffect(() => {
    if (!props.answer) {
      // select audio.
      let question_audio = null;
      let defaultSelectedVoiceTemp = null;
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoiceTemp = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoiceTemp);
    }

    // componentWillUnmount equivalent
    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        let question_audio = null;
        let defaultSelectedVoiceTemp = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoiceTemp = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setQuestionAudio(question_audio);
        setDefaultSelectedVoice(defaultSelectedVoiceTemp);
        setAudioRetryCount(0);
        setAudioFailed(false);
        if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }
        lastSoundPerRef.current = 0;
        lastSoundPerTimeRef.current = null;
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount <= 1) {
        clearInterval(intervalIdRef.current);
        return 0;
      }
      return prevCount - 1;
    });
  };

  const handleSongFinishedPlaying = () => {
    if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; }
    setSoundStatus(false);
    props.soundChecked();
    props.showResult();
  };

  const handleAudioError = (err) => {
    console.error('Audio playback error:', err);
    if (audioRetryCount < MAX_AUDIO_RETRIES) {
      setSoundStatus(false);
      setSoundPer(0);
      setAudioRetryCount(prev => prev + 1);
      setTimeout(() => { setSoundKey(prev => prev + 1); setSoundStatus(true); }, 300);
    } else {
      setAudioFailed(true);
      setSoundStatus(false);
      props.soundChecked();
    }
  };

  useEffect(() => {
    if (soundStatus && secondCount === 0 && !audioFailed) {
      lastSoundPerRef.current = 0;
      lastSoundPerTimeRef.current = Date.now();
      stallWatchdogRef.current = setInterval(() => {
        const timeSinceProgress = Date.now() - (lastSoundPerTimeRef.current || Date.now());
        if (timeSinceProgress > STALL_TIMEOUT_MS && lastSoundPerRef.current > 0) {
          clearInterval(stallWatchdogRef.current);
          stallWatchdogRef.current = null;
          handleAudioError({ type: 'stall' });
        }
      }, 1000);
    }
    return () => { if (stallWatchdogRef.current) { clearInterval(stallWatchdogRef.current); stallWatchdogRef.current = null; } };
  }, [soundStatus, secondCount, audioFailed]);

  const removeItem = (array, item) => {
    for (var i in array) {
      if (array[i] == item) {
        array.splice(i, 1);
        break;
      }
    }
  };

  const handleSongPlaying = (obj) => {
    const newPer = obj.position * 100 / obj.duration;
    // if (newPer > 10) return; // stop updating progress after 10%
    setSoundPer(newPer);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
    if (newPer !== lastSoundPerRef.current) {
      lastSoundPerRef.current = newPer;
      lastSoundPerTimeRef.current = Date.now();
    }
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const timerRecord = () => {
    setRecordCount(prevCount => {
      if (prevCount === 40) {
        clearInterval(recordIdRef.current);
        stop();
      }
      return prevCount + 1;
    });
  };

  const handleChange = (event) => {
    props.showResult();
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    }).map(function (i) {
      return i.id;
    });
    let arr = [...selectedValue];
    let val = event.target.value;
    arr.includes(parseInt(val)) ? removeItem(arr, parseInt(val)) : arr.push(parseInt(val));
    props.submit({ 'answer': arr, 'correct': correct }, true);
    setSelectedValue(arr);
    setResultObj({ 'answer': arr, 'correct': correct });
  };

  const updateCorrect = () => {
    let correct = props.data.option.filter(function (item) {
      return item.correct == 1;
    }).map(function (i) {
      return i.id;
    });
    props.submit({ 'answer': [], 'correct': correct });
    setCorrectFlag(false);
    setResultObj({ 'answer': [], 'correct': correct });
  };

  const skip = () => {
    clearInterval(intervalIdRef.current);
    setSecondCount(0);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const changeAudio = (selected) => {
    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestionAudio(`${s3base}/${selected_audio[0].value}`);
  };

  // Handle reset effect
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      setIntervalId(newIntervalId);
      setReset(false);
      setSelectedValue([]);
    }
  }, [reset]);

  let questionText = "";
  if (props.restart) {
    props.restartQue();
  }
  
  useEffect(() => {
     if (props.stopRecording) {
    stopTest();
  }
  },[props.stopRecording])
  
  if (props.data) {
    questionText = props.data.question_mcq;
    if (correctFlag) {
      updateCorrect();
    }
  }
console.log(props);
  const getOptionClass = (item) => {
    const isSelected = props?.selectedArray.includes(item.id.toString());
    const isCorrect = props.correctArray.includes(item.id.toString());
    console.log("ID : ",item.id,"isSelected ",isSelected," IsCorrect : ",isCorrect);
    
    if (isSelected && isCorrect) return "option-correct-selected";
    if (isSelected && !isCorrect) return "option-wrong-selected";
    if (!isSelected && isCorrect) return "option-correct-not-selected";

    return "option-default";
  };
  return (
    <>
    {
      !props.resultMode && (
          <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>
      )
    }
      <div className="container-fluid">
        <div className="row d-flex flex-column-reverse flex-md-row-reverse">
          {!props.resultMode && (
            <Col xs={12} md={4}>
              <div className="col-lg-12 p-0 text-center">
                <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
                  {/* <p>Current Status:{soundStatus == true && secondCount !== 0 && !isRecording && ' Begining in ' + secondCount + ' seconds'}
                  {secondCount == 0 && blobURL === '' && !isRecording && ' Playing'}</p>
                  <br></br> */}
                  <div className="w-100 text-white p-4">
                    <div className="d-flex justify-content-end w-100 align-items-center" style={{ minHeight: "20px" }}>
                      {secondCount === 0 && blobURL === "" && !isRecording && (
                          <p className="mb-0 fs-10">{remainingTime}</p>
                      )}
                    </div>
                    <div className="d-flex justify-content-center align-content-center w-100 gap-3 py-1">
                      <i className="fa fa-play" aria-hidden="true"></i>
                      <div className="flex-grow-1">
                        <ProgressBar
                          style={{ backgroundColor: "#e9ecef", height: "15px" }}
                          barStyle={{ backgroundColor: "#4493e0" }}
                          now={soundPer}
                        />
                        {/* <Progress color="info" value={(soundPer)} /> */}
                      </div>
                    </div>
                    <div className="d-flex justify-content-start w-100 align-items-center" style={{ minHeight: "20px" }} >
                      {soundPer === 100 ? (
                        <p className="mb-0 fs-10 mx-4">Completed</p>
                      ) : soundStatus === true &&
                        secondCount !== 0 &&
                        !isRecording ? (
                        <p className="mb-0 fs-10 mx-4">
                          The clip will begin in {secondCount} seconds
                        </p>
                      ) : (
                        <p className="mb-0 fs-10 mx-4 invisible"></p>
                      )}
                    </div>
                    {/* Volume
                    <Input placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" /> */}
                    <br></br>
                    <div className="w-100 d-flex justify-content-center align-items-center">
                      <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                        <Form.Control
                          placeholder="Volume"
                          type="range"
                          min="0"
                          defaultValue={volume}
                          step="1"
                          onInput={(e) => changeRange(e)}
                          max="100"
                        />
                      </div>
                    </div>
                    {!props.testMode && (
                      <div className="d-flex justify-content-between">
                        <div className="stop-btn">
                          {secondCount !== 0 &&
                            blobURL === "" &&
                            !isRecording && (
                              <Button variant="success" onClick={skip} size="sm">
                                Skip
                              </Button>
                            )}
                        </div>
                        <div className="stop-btn clearfix">
                          <div className="select-voice pull-left">
                            {defaultSelectedVoice !== null && (
                              <SelectVoiceDropDown
                                voices={props.voices}
                                selected={defaultSelectedVoice}
                                changeAudio={changeAudio}
                              />
                            )}
                          </div>
                          <div className="select-speed pull-right">
                            <PlaybackSpeedBtns
                              changePlaybackSpeed={changePlaybackSpeed}
                              playbackSpeed={playbackSpeed}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <Col xs={12}>
                  {props.data &&
                    !props.resultMode &&
                    soundStatus &&
                    secondCount === 0 && (
                      <Sound
                        url={questionAudio}
                        playStatus={Sound.status.PLAYING}
                        onFinishedPlaying={handleSongFinishedPlaying}
                        onPlaying={handleSongPlaying}
                        onError={handleAudioError}
                        volume={volume}
                        playbackRate={playbackSpeed}
                        key={soundKey}
                      />
                    )}
                </Col>
                <Col xs={12}>
                  {blobURL && <audio src={blobURL} controls="controls" />}
                </Col>
              </div>
            </Col>
          )}
          <Col xs={12} md={!props.resultMode ? 8 : 12}>
           {/* {!props.resultMode && <h3 className="question">{questionText}</h3>} */}
           <h3 className={props.resultMode ? "reading-text text-start"  : "question mock-resource-text"}>{questionText}</h3>
            <div className="answers mock-container">
              {/* {props.data &&
                !props.resultMode &&
                props.data.option.map(function (item) {
                  return (
                    <React.Fragment key={item.id}>
                      <Form.Label
                        // className={`
                        //   ${
                        //   props.answer && item.correct === 1 && "correct-line"
                        // } 
                        //   ${
                        //   selectedValue.includes(item.id)
                        //     ? "selected-option mb-1"
                        //     : ""
                        // }`}
                        className={`
                          option-wrapper
                          ${getOptionClass(item)}
                          ${selectedValue.includes(item.id) ? "selected-option mb-1" : ""}
                        `}
                      >
                        <Checkbox
                          onChange={!props.resultMode && handleChange}
                          checked={selectedValue.includes(item.id)}
                          value={item.id}
                          // color="default"
                          sx={{
                            color: "##D3D3D3 !important",
                            "&.Mui-checked": {
                              color: "#0081a4 !important",
                            },
                          }}
                          inputProps={{ "aria-label": "secondary checkbox" }}
                          name="answer"
                        />{" "}
                        {item.options}
                      </Form.Label>
                    </React.Fragment>
                  );
                })} */}
              {props.data &&
                !props.resultMode &&
                props.data.option.map(function (item) {
                  return (
                    <React.Fragment key={item.id}>
                      <Form.Label
                        className={`${
                          props.answer &&
                          (item.correct === 1
                            ? selectedValue.includes(item.id)
                              ? "correct-line"
                              : "blue-line"
                            : selectedValue.includes(item.id)
                            ? "red-line"
                            : "")
                        }`}
                      >
                        <span className={`${selectedValue.includes(item.id)? "selected-option mb-1": ""}`}>
                          <Checkbox
                            checked={selectedValue.includes(item.id)}
                            value={item.id}
                            // color="default"
                            sx={{
                              color: "var(--checkbox-default) !important",
                              "&.Mui-checked": {
                                color: "var(--checkbox-checked) !important",
                              },
                            }}
                            onChange={handleChange}
                            inputProps={{ "aria-label": "secondary checkbox" }}
                            name="answer"
                          />{" "}
                          {item.options}
                        </span>
                      </Form.Label>
                    </React.Fragment>
                  );  })}
            </div>
          </Col>
        </div>
      </div>
    </>
  );
};

export default McqMulti;